export const getPresetRangeEpoch = (days: number, now: Date = new Date()): { fromEpoch: number; toEpoch: number } => {
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();
  const day = now.getUTCDate();

  const toMs = Date.UTC(year, month, day, 23, 59, 59, 999);
  const fromMs = Date.UTC(year, month, day - (days - 1), 0, 0, 0, 0);

  return {
    fromEpoch: Math.floor(fromMs / 1000),
    toEpoch: Math.floor(toMs / 1000),
  };
};
